import React, { useEffect } from 'react'

import { const_var, params } from '../../../../redux/reducers/reducer';

import FrontStorage from './FrontStorage';
import BackStorage from './BackStorage';
import LeftStorage from './LeftStorage';
import RightStorage from './RightStorage';
import { useDispatch } from 'react-redux';
import { updateDoorWindowsArray } from '../../../../action';
import { wallNameByStorageSec } from '../../../../redux/reducers/building_component/componentReducer';

const Storage = () => {
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (const_var.newDoorsArray?.length > 0) {
            if (!params.p_u_c) {
                const doorArrOnLean = const_var.newDoorsArray.filter(item => wallNameByStorageSec[item.userData.wallName] === 'center-storage-back')
                if (doorArrOnLean.length > 0) {
                    const newDoorArrOnLean = const_var.newDoorsArray.filter(item => wallNameByStorageSec[item.userData.wallName] !== 'center-storage-back')
                    dispatch(updateDoorWindowsArray(newDoorArrOnLean,true));
                }
            }
        }
    }, [params.p_u_c])

    return (
        <>
            {!params.nostorage && params.cB_addStorage_check_front && <FrontStorage />}
            {!params.nostorage && params.p_u_c && <BackStorage />}
            {!params.nostorage && params.cB_addStorage_check_left && <LeftStorage />}
            {!params.nostorage && params.cB_addStorage_check_right && <RightStorage />}
        </>
    )
}

export default Storage